import { Static, Type } from '@sinclair/typebox';
import { StringEnum } from '../utils/typebox';

export const UNILOGIN_PROVIDERS: UniLoginProvider[] = ['linkedin', 'instagram', 'facebook'];

export const UniLoginProviderSchema = StringEnum(['linkedin', 'instagram', 'facebook'], {
  description: 'The provider to connect with UniLogin.',
});

/** The one-time code shown to link the UniLogin extension, e.g. `SW3T-Z4AJ-KNEY`. */
export const UNILOGIN_EXTENSION_CODE_PATTERN = '^[23456789ABCDEFGHJKMNPQRSTVWXYZ]{4}(?:-[23456789ABCDEFGHJKMNPQRSTVWXYZ]{4}){2}$';

/** A browser language tag, e.g. `en-US`. */
export const BROWSER_LANGUAGE_PATTERN = '^[A-Za-z]{1,8}(?:-[A-Za-z0-9]{1,8})*$';

export const CreateUniLoginHostedAuthRequestBodySchema = Type.Object(
  { provider: UniLoginProviderSchema },
  { additionalProperties: false },
);

export const UniLoginExtensionStoreUrlsSchema = Type.Object(
  {
    chrome: Type.Optional(Type.String({ format: 'uri' })),
    edge: Type.Optional(Type.String({ format: 'uri' })),
    firefox: Type.Optional(Type.String({ format: 'uri' })),
    safari: Type.Optional(Type.String({ format: 'uri' })),
  },
  { additionalProperties: false },
);

export const UniLoginExtensionDownloadUrlsSchema = Type.Object(
  {
    edge: Type.Optional(Type.String({ format: 'uri' })),
    safari: Type.Optional(Type.String({ format: 'uri' })),
  },
  { additionalProperties: false },
);

export const CreateUniLoginHostedAuthRequestResponseSchema = Type.Object(
  {
    object: Type.Literal('UniLoginHostedAuthRequest'),
    provider: UniLoginProviderSchema,
    request_id: Type.String({ format: 'uuid' }),
    handoff_token: Type.String({ minLength: 32, maxLength: 512 }),
    extension_code: Type.String({ pattern: UNILOGIN_EXTENSION_CODE_PATTERN }),
    extension_code_expires_at: Type.String({ format: 'date-time' }),
    deep_link: Type.String({ minLength: 1, maxLength: 1024 }),
    expires_at: Type.String({ format: 'date-time' }),
    extension_bridge_url: Type.String({ format: 'uri' }),
    publisher_name: Type.Optional(Type.String()),
    extension_store_urls: Type.Optional(UniLoginExtensionStoreUrlsSchema),
    extension_download_urls: Type.Optional(UniLoginExtensionDownloadUrlsSchema),
  },
  { additionalProperties: false },
);

export const UniLoginHostedAuthStatusResponseSchema = Type.Object(
  {
    object: Type.Literal('UniLoginHostedAuthStatus'),
    status: StringEnum(['pending', 'claimed', 'account_mismatch', 'approved', 'processing', 'declined', 'expired']),
  },
  { additionalProperties: false },
);

export type CreateUniLoginHostedAuthRequestResponse = Static<typeof CreateUniLoginHostedAuthRequestResponseSchema>;
export type UniLoginHostedAuthStatusResponse = Static<typeof UniLoginHostedAuthStatusResponseSchema>;
export type UniLoginProvider = Static<typeof UniLoginProviderSchema>;
